namespace $.$$ {

	$mol_style_define( $shm_hitalama_speech_picker, {

		Trigger: {
			padding: 0,
		},

		Trigger_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},

		Mic: {
			flex: {
				direction: 'column',
			},
			align: {
				items: 'stretch',
			},
		},

		Speaker: {
			flex: {
				direction: 'column',
			},
			align: {
				items: 'stretch',
			},
		},

	} )

}
